// This route is used for all pages that are only for editors and administrators (hide from read-only users).

import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { userCanEdit } from '../../utils/permissionsOptions';

const ProtectedPrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (!rest.loggedIn) {
        return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
      }
      return userCanEdit(rest.user)
        ? <Component {...props} />
        : <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
    }}
  />
);


function mapStateToProps(state) {
  return {
    loggedIn: state.users.currentUserId && sessionStorage.jwt,
    user: state.users.roster ? state.users.roster[state.users.currentUserId] : null,
  };
}

export default connect(mapStateToProps)(ProtectedPrivateRoute);



// WEBPACK FOOTER //
// ./src/components/common/ProtectedPrivateRoute.js